import * as Yup from 'yup';

export const campgainCreateSchema = Yup.object().shape({
  campaignOwner: Yup.string().required('Campaign owner is required'),
  type: Yup.string().required('Type is required'),
  campaignName: Yup.string().required('Campaign name is required'),
  status: Yup.string().required('Status is required'),
  startDate: Yup.date().required('Start date is required').nullable(),
  endDate: Yup.date().required('End date is required').nullable().min(
    Yup.ref('startDate'),
    'End date cannot be before start date'
  ),
  expectedRevenue: Yup.number()
    .typeError('Expected revenue must be a number')
    .required('Expected revenue is required'),
  budgetCost: Yup.number()
    .typeError('Budget cost must be a number')
    .required('Budget cost is required'),
  actualCost: Yup.number()
    .typeError('Actual cost must be a number')
    .required('Actual cost is required'),
  expectedResponse: Yup.number()
    .typeError('Expected response must be a number')
    .required('Expected response is required'),
  numberSent: Yup.number()
    .typeError('Number sent must be a number')
    .required('Number sent is required'),
  description: Yup.string().required('Description is required'),
});

export const CAMPGAIN_CREATE_INITIAL_VALUES = {
  campaignOwner: '',
  type: '',
  campgainName: '',
  status: '',
  startDate: null,
  endDate: null,
  expectedRevenue: '',
  budgetCost: '',
  actualCost: '',
  expectedResponse: '',
  numberSent: '',
  description: '',
};
